import React, { useState } from "react";
import { motion } from "framer-motion";
import { FaHeart } from "react-icons/fa";
import { FaComment } from "react-icons/fa";
import { FaShare } from "react-icons/fa";
import { GoArrowRight } from "react-icons/go";
import ImageWithLoader from "../../../components/imageLoader/ImageWithLoader";
import Url from "../../../url/Url";
import anonymous from "../../../assets/images/anonymous.jpg.webp";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import NewsService from "../../../services/News";
import { FiHeart } from "react-icons/fi";
import { timeAgo } from "../../../utiles/persianFormat";

const NewsCard = ({ item, isCommentsModal, setIsCommentsModal, setId }) => {

  const [isMore, setIsMore] = useState(null)
  const navigate = useNavigate();
  // console.log(item)

  const handleShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          text: "https://api.7-trade.ir/newsDetail/" + item._id,
        });
      } catch (err) { }
    } else {
    }
  };

  function toPersianNumber(num) {
    return num.toString().replace(/\d/g, (d) => "۰۱۲۳۴۵۶۷۸۹"[parseInt(d)]);
  }

  const [isLike, setIsLike] = useState(item?.isLiked || false);
  const [likesCount, setLikesCount] = useState(item?.likesCount || 0);


  console.log("likesCount:", likesCount);

  async function handleLikeAndDisLikeNews(Id) {
    if (!Id) return;

    const previousLike = isLike;
    const previousCount = likesCount;

    try {
      const param = { newsId: Id };

      if (!isLike) {
        setIsLike(true);
        setLikesCount((prev) => prev + 1);
        await NewsService.LikeNews(param);
      } else {
        setIsLike(false);
        setLikesCount((prev) => prev - 1);
        await NewsService.DisLikeNews(param);
      }
    } catch (err) {
      // اگر خطا رخ داد، state ها را برگردان
      setIsLike(previousLike);
      setLikesCount(previousCount);
      console.error("Error liking/disliking news:", err);
    }
  }
  return (
    <motion.article
      onClick={() => navigate(`/newsDetail/${item?._id}`)}
      className="bg-white rounded-2xl border  border-gray-200 shadow-xl hover:shadow-lg transition-all duration-300 overflow-hidden w-full"
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.35 }}
      whileHover={{ scale: 1.02 }}
    >
      <div className="relative cursor-pointer h-48 overflow-hidden">
        <ImageWithLoader src={`${Url}${item?.imageId?.path}`}></ImageWithLoader>
        {/* <img className="w-full h-full object-cover filter blur-[1px]" src="https://storage.googleapis.com/uxpilot-auth.appspot.com/3b76f829d0-db596e29588eb705015b.png" alt="bitcoin cryptocurrency trading chart financial news" /> */}
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
        <div className="absolute top-4 right-4 bg-blue-600 text-white text-xs px-3 py-1.5 rounded-full font-medium shadow-lg">
          {item?.newsTypes || "بازار ارز"}
        </div>
        <div className="absolute bottom-4 right-4 left-4">
          <h2 className="text-2xl font-bold text-white mb-2 text-right line-clamp-2 drop-shadow-lg">
            {item.title}
          </h2>
        </div>
      </div>

      <div className="p-6">
        <div className="flex items-center space-x-2 border-b pb-2">
          <button
            onClick={(e) => {
              e.stopPropagation();
              handleLikeAndDisLikeNews(item._id)
            }}
            className={`flex items-center text-sm text-gray-400 gap-1 hover:text-red-500 transition-colors ${isLike ? "text-red-500" : "text-secondary "
              }`}
          >
            <div className={" flex items-center pl-3"}>
              <FaHeart size={15} className="mr-2 text-base" />
            </div>

            <span className="font-semibold">{likesCount}</span>
          </button>

          {/*<button onClick={handleLikeAndDisLikeNews} className="flex items-center justify-center gap-1 text-sm text-gray-400 hover:text-red-500 transition-colors">*/}
          {/*    <FaHeart size={20} className={isLike ? "text-red-600" : "text-gray-400"} />*/}
          {/*    <span className="font-semibold">{likesCount}</span>*/}
          {/*</button>*/}

          <button
            onClick={(e) => {
              e.stopPropagation();
              setIsCommentsModal(true);
              setId(item?._id)
            }}
            className="flex justify-center items-center text-sm text-gray-400 hover:text-blue-500 transition-colors">
            <div className={" flex items-center pl-3"}>
              <FaComment
                className="mr-2 fas fa-comment"
                size={14}
              ></FaComment>
            </div>

            <span className="font-semibold">{item?.commentsCount}</span>
          </button>

          <button
            onClick={(e) => {
              e.stopPropagation();
              handleShare();
            }}

            className="flex items-center text-sm text-gray-400 hover:text-green-500 transition-colors"
          >
            <div className={" flex items-center pl-3"}>
              <FaShare className="fas fa-share" size={15}></FaShare>
            </div>
          </button>
        </div>
        <div className="flex items-center justify-between text-xs mt-3 text-gray-500 mb-5">
          <div className="flex items-center space-x-2 space-x-reverse gap-2">
            <img
              src={anonymous}
              alt="نویسنده"
              className="w-8 h-8 rounded-full border-2 border-white shadow-sm"
            />
            <span className="font-medium text-gray-700">
              {item?.adminId?.userName || "ادمین ناشناس"}
            </span>
          </div>

        </div>
        <div className="w-full mb-5 flex flex-col justify-end items-end">
          <p
            dir="rtl"
            className={`w-full text-gray-700 text-sm leading-relaxed text-right ${isMore !== item._id ? "line-clamp-1" : ""
              }`}
          >
            {item?.body}
          </p>

          <span
            className="text-xs text-blue-600 font-bold text-end w-full cursor-pointer"
            onClick={(e) => {
              e.stopPropagation();

              if (isMore === item._id) {
                setIsMore(null);
              } else {
                setIsMore(item._id);
              }
            }}
          >
            {isMore === item._id ? "less..." : "more..."}
          </span>
        </div>
        {isMore === item._id &&
          <div className="flex flex-wrap gap-2 mb-5">
            {item?.hashtags?.map((it, index) => (
              <span
                key={index}
                className="text-xs text-blue-600 bg-blue-50 px-3 py-1.5 rounded-full font-medium"
              >
                #{it}
              </span>
            ))}
          </div>
        }


        {/* Interaction Section */}
        <div className="flex items-center justify-between pt-4 border-t border-gray-100">
          <span dir="rtl" className="px-3 py-1.5 rounded-full text-xs text-gray-500">
            {timeAgo(item.createdAt)}
          </span>
          {/* <Link
            to={`/newsDetail/${item?._id}`}
            className="flex items-center justify-center w-12 h-12 bg-blue-600 hover:bg-blue-700 text-white rounded-xl transition-all duration-200 hover:scale-105 shadow-md"
          >
            <GoArrowRight
              strokeWidth={1}
              size={25}
              className="fas fa-arrow-right text-lg"
            ></GoArrowRight>
          </Link> */}
        </div>
      </div>
    </motion.article>
  );
};

export default NewsCard;
